import { takeLatest, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getTripSuccess, updateTripRequest, updateTripSuccess } from '../../slices/trip';

function* tripUpdateWorker({
  payload: { tripId, itineraryModeToRemove, itineraryIdToRemove, selectedFlightFareIndex },
}) {
  try {
    const url = '/trips/update';

    const config = {
      method: 'post',
      url,
      data: JSON.stringify({
        tripId,
        itineraryModeToRemove,
        itineraryIdToRemove,
        selectedFlightFareIndex,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);
    yield put(updateTripSuccess());
    if (data) {
      yield put(
        getTripSuccess({
          tripId,
          trip: {
            ...(data.trip || {}),
            maxCharsNoteToAirDesk: data.maxCharsNoteToAirDesk,
            doShowNoteToAirDeskInput: data.doShowNoteToAirDeskInput,
            doShowCompanyNameInput: data.doShowCompanyNameInput,
            doShowAgencyPlanningFeesPerPassenger: data.doShowAgencyPlanningFeesPerPassenger,
            separatePnrForTravelTypes: data.separatePnrForTravelTypes,
            doSupportsCardUpsertOperations: data.doSupportsCardUpsertOperations,
            tripBookingFees: data.tripBookingFees,
          },
        }),
      );
    }
  } catch (error) {
    yield put(updateTripSuccess());
  }
}

function* tripUpdateWatcher() {
  yield takeLatest(updateTripRequest.toString(), tripUpdateWorker);
}

export default tripUpdateWatcher;
